import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { StatusBadge } from "@/components/StatusBadge";
import { Boxes, AlertTriangle } from "lucide-react";
import { angka } from "@/lib/format";

export function ClientMaterialsButton({ client }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async (e) => {
    e.stopPropagation();
    setOpen(true); setLoading(true);
    try {
      const res = await api.get(`/clients/${client.id}/materials`);
      setData(res.data);
    } finally { setLoading(false); }
  };

  return (
    <>
      <Button variant="outline" size="sm" onClick={load} data-testid={`client-materials-${client.id}`}>
        <Boxes className="h-4 w-4 mr-1" /> Material
      </Button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent className="w-full sm:max-w-2xl overflow-y-auto scrollbar-thin" onClick={(e) => e.stopPropagation()}>
          <SheetHeader>
            <SheetTitle className="font-display">Material Klien — {client.name}</SheetTitle>
          </SheetHeader>
          <p className="text-xs text-muted-foreground mt-1">Diambil otomatis dari surat jalan &amp; pengembalian aplikasi material.</p>
          <div className="py-6">
            {loading ? <div className="h-40 rounded-md bg-muted animate-pulse" /> : !data ? null : data.materials.length === 0 ? (
              <div className="text-center text-muted-foreground py-12 text-sm">
                <Boxes className="h-10 w-10 mx-auto mb-2 opacity-40" />
                Belum ada transaksi material untuk klien ini.
              </div>
            ) : (
              <div className="space-y-4">
                <div className="text-sm text-muted-foreground">{data.project_count} proyek · {data.materials.length} baris material</div>
                <div className="rounded-md border overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead><tr className="bg-muted/40 border-b text-xs">
                      {["Proyek", "Material", "Dikirim", "Kembali", "Saldo", "Tarif"].map((h) => (
                        <th key={h} className={`px-3 py-2 ${["Dikirim", "Kembali", "Saldo"].includes(h) ? "text-right" : "text-left"}`}>{h}</th>
                      ))}
                    </tr></thead>
                    <tbody>
                      {data.materials.map((m, i) => (
                        <tr key={i} className="border-b last:border-0 hover:bg-white/5">
                          <td className="px-3 py-2 text-xs">{m.project_name}</td>
                          <td className="px-3 py-2 font-medium">{m.material_name}<div className="text-[11px] text-muted-foreground">{m.material_code}</div></td>
                          <td className="px-3 py-2 text-right tabular-nums">{angka(m.delivered)}</td>
                          <td className="px-3 py-2 text-right tabular-nums">{angka(m.returned_good)}</td>
                          <td className="px-3 py-2 text-right tabular-nums font-semibold">{angka(m.balance)}</td>
                          <td className="px-3 py-2">
                            {m.has_rate ? <StatusBadge status="Aktif" /> : (
                              <span className="inline-flex items-center gap-1 text-xs text-rose-600"><AlertTriangle className="h-3 w-3" /> Belum Ada Tarif</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
